import { getTranslation } from 'helpers/getTranslation';

export const getRegistrationSourceLabel = (
  registrationSource: string | null | undefined,
): string => {
  if (registrationSource === 'plugin') {
    return getTranslation('common.text.plugin');
  }

  if (registrationSource === 'web') {
    return getTranslation('common.text.web');
  }

  return '-';
};
